import { api } from './client'

export type SessionStatus = 'pending_payment' | 'active' | 'expired' | 'cancelled'

export interface StartSessionInput {
  plate: string
  zoneId: string
  minutes: number
}

export interface StartSessionResult {
  sessionId: string
  amount: number
  currency: string
  paymentUrl?: string
  expiresAt: string
}

export interface SessionDetail {
  id: string
  plate: string
  status: SessionStatus
  amount: number
  currency: string
  startedAt: string
  expiresAt: string
  zone: { id: string; code: string; name: string; city: string }
  payment: { status: string; provider: string } | null
}

export interface ExtendResult {
  sessionId: string
  amount: number
  currency: string
  paymentUrl?: string
  expiresAt: string
}

export async function startSession(input: StartSessionInput): Promise<StartSessionResult> {
  return api<StartSessionResult>('/sessions/start', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export async function getSession(id: string): Promise<SessionDetail> {
  return api<SessionDetail>(`/sessions/${id}`)
}

export async function extendSession(id: string, minutes: number): Promise<ExtendResult> {
  return api<ExtendResult>(`/sessions/${id}/extend`, {
    method: 'POST',
    body: JSON.stringify({ minutes }),
  })
}

export async function stopSession(id: string): Promise<{ ok: true; stoppedAt: string }> {
  return api<{ ok: true; stoppedAt: string }>(`/sessions/${id}/stop`, { method: 'POST' })
}
